import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import moment from "moment";
import { useTranslation } from 'react-i18next';


import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import ExtratoRoyaltiesDM2 from "beaktMatriz/views/Royalties/ExtratoRoyaltiesDM2";
import Slide from "@material-ui/core/Slide";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Help from "@material-ui/icons/Help";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from '@material-ui/core/CircularProgress';

//services
import { SessionContext } from "beaktShared/services/session";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { formateDate, transformValueFloattoFormated } from "beaktShared/helpers/masks";

//syles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
export default function RoyaltieForm({ addItem, item, handleView }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    
    const { register, handleSubmit, setValue, errors, clearError } = useForm({ mode: "onChange" });

    const [loading, setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    useEffect(() => {
        let dttemp = formateDate(moment(Date.now()));
        setValue("dtAceite", dttemp);
    }, []);

    const [parcelas, setparcelas] = React.useState('');
    const [valorParcelas, setvalorParcelas] = React.useState('');
    useEffect(() => {

        let dttemp = formateDate(moment(Date.now()));
        setValue("dtAceite", dttemp);

        if (!item.royaltieId)
            return;

        verificaValorByParcelas();
    }, [item]);

    const verificaValorByParcelas = (formapgto) => {
        if (item.parcelar <= 0) {
            setvalorParcelas(item.valorReceberPagar);
            setformapgto(1);
            setValue("formapgto", "1");
            setparcelas(1);
        }
        else if (item.parcelar > 0) {
            if (formapgto === "1" || item.mediaParcelas == 1) {
                setformapgto(1);
                setValue("formapgto", "1");
                setvalorParcelas(item.valorFinal != null ? item.valorFinal : item.valorReceberComTaxaAntecipacao);
                setparcelas(1);
            }
            else {
                let valorParcela;

                if (item.pendenciaValorMesAnterior > 0) {
                    valorParcela = item.totalReceberAVista;
                } else {
                    let CreditoAvista = item.valorCreditosAVista - item.valorDebitos;

                    if (CreditoAvista > 0)
                        valorParcela = item.valorCreditos / item.mediaParcelas;
                    else
                        valorParcela = item.valorReceberPagar / item.mediaParcelas;

                    valorParcela = Math.round(valorParcela * 100) / 100;
                }

                setvalorParcelas(valorParcela);
                setparcelas(item.mediaParcelas);
                setformapgto(2);
                setValue("formapgto", "2");
            }
        }
    }

    const [formapgto, setformapgto] = React.useState('');
    const hangleFormaPgto = event => {
        setformapgto(event.target.value);
        setValue("formapgto", event.target.value);
        if (event.target.value !== "")
            clearError("formapgto");
        verificaValorByParcelas(event.target.value);
    };

    const extractErrorMessage = (message) => {
        if (typeof message === "string") return message;
        if (message && typeof message === "object" && message.message) return message.message;
        return JSON.stringify(message);
    };

    const onSubmit = () => {

        let dtAceite = new Date();

        let obj = {
            ...item,
            usuarioAceiteId: parseInt(session.id),
            dataAceite: dtAceite,
            parcelaSelecionadaAceite: parcelas
        };

        let endPoint = "royalties/aceitefechamento";
        setloading(true);
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(extractErrorMessage(result.message), 'danger');
                setloading(false);
                return false;
            }

            setloading(false);
            addItem(t('information_message.accepted_successfully'));
        });
    };

    const [showModal, setshowModal] = React.useState(false);
    const showExtrato = () => {
        setshowModal(true);
        /*history.push({
            pathname: '/adminclinic/extratoroyalties',
            state: { royaltieId: item.royaltieId, from: 'clinic' }
        });*/
    };
    
    return (
        <div className="maxContent">

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }

            <form onSubmit={handleSubmit(onSubmit)} className="no-print">
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('information_message.royalties_closing')} <small>{t('label.track_status')}</small>
                                    <input className={classes.hidden} defaultValue={0} name="id" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>

                                <div style={{ maxWidth: '500px', margin: '0 auto' }}>

                                    <h4 style={{ textAlign: 'right', fontWeight: 'bold' }}>{t('label.referent')}: {item.mesAno} </h4>
                                    <div style={{ border: '1px dashed gray', padding: '10px' }}>

                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <div style={{ border: '1px solid #61a4c982', padding: '10px 15px', background: '#61a4c926' }}>
                                                    <h3 style={{ textAlign: 'right' }}> {t('label.total_billing')}: {transformValueFloattoFormated(item.valorFaturamento ? item.valorFaturamento : 0)} </h3>
                                                </div>
                                            </GridItem>
                                        </GridContainer>
                                        <br />

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> STATUS:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>{item.status}</label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.value_royalties')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorRoyalties ? item.valorRoyalties : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.card_value')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorCartao ? item.valorCartao : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.split_matrix')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>
                                                    {transformValueFloattoFormated(item.valorRepasseSliptCartaoMatriz ? item.valorRepasseSliptCartaoMatriz : 0)}
                                                </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.split_clinic')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>
                                                    {transformValueFloattoFormated(item.valorRepasseSliptCartaoClinica ? item.valorRepasseSliptCartaoClinica : 0)}
                                                </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.credit_value_closing')}:
                                                    <Tooltip title="Exceto moderninha e crédito de Parcelamentos anteriores" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip>
                                                </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>  {transformValueFloattoFormated(item.valorCreditos ? item.valorCreditos : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.credit_cash_amount')} :
                                                    <Tooltip title="Moderninha + Crédito de parcelamentos anteriores" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip> </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorCreditosAVista ? item.valorCreditosAVista : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.debit_value')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorDebitos ? item.valorDebitos : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        {item.valorReceberAVista > 0 &&
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <h6 className="tRightForm"> {t('label.value_receive_in_cash')}:
                                                        <Tooltip title="Valor crédito a vista - Valor débito" placement="top">
                                                            <Help className="question" />
                                                        </Tooltip> </h6>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <label> {transformValueFloattoFormated(item.valorReceberAVista ? item.valorReceberAVista : 0)} </label>
                                                </GridItem>
                                            </GridContainer>
                                        }

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.accepted_date')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {item.dataAceite ? formateDate(item.dataAceite) : ""} </label>
                                                {!item.dataAceite &&
                                                    <TextField
                                                        style={{ marginBottom: '10px' }}
                                                        variant="outlined"
                                                        inputRef={register({ required: t('label.required') })}
                                                        name="dtAceite"
                                                        InputLabelProps={{ shrink: true }}
                                                        disabled
                                                    />}
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.payment_date')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {item.dataPagamento ? formateDate(item.dataPagamento) : t('information_message.not_yet_informed')} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.total_a')} {item.valorReceberPagar > 0 ? t('label.to_receive') : t('label.to_pay')}:
                                                    <Tooltip title="Valor total arrecadado no mês" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip> </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorReceberPagar ? item.valorReceberPagar : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        {item.pendenciaValorMesAnterior > 0 && (
                                            <>
                                                <hr style={{ borderColor: '#e0e0e0', margin: '6px 0' }} />
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <h6 style={{ textAlign: 'center', marginBottom: 4 }}>Pendência do mês anterior</h6>
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h6 className="tRightForm">Valor original:</h6>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <label>{transformValueFloattoFormated(item.pendenciaValorMesAnterior)}</label>
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h6 className="tRightForm">Pendência atualizada (com juros):</h6>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <label style={{ color: '#f44336' }}>{transformValueFloattoFormated(item.pendenciaAtualizada)}</label>
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h6 className="tRightForm">Novo total a receber:</h6>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <label style={{ fontWeight: 'bold' }}>{transformValueFloattoFormated(item.valorReceberPagar)}</label>
                                                    </GridItem>
                                                </GridContainer>
                                                <hr style={{ borderColor: '#e0e0e0', margin: '6px 0' }} />
                                            </>
                                        )}

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.billing_in_cash_or_installed')}? </h6>

                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    variant="outlined"
                                                    value={formapgto}
                                                    onChange={hangleFormaPgto}
                                                    name="formapgto"
                                                    ref={() => register({ name: "formapgto" }, { required: true })}
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={
                                                        item.dataAceite ||
                                                        !(item.valorReceberPagar > 0 && item.mediaParcelas > 1)
                                                    }>
                                                    <MenuItem value="1"> {t('label.in_cash')} </MenuItem>
                                                    {
                                                        item.valorReceberPagar > 0 && item?.mediaParcelas > 1 &&
                                                        (
                                                        <MenuItem value="2">{t('label.parceled')} </MenuItem>
                                                        )
                                                    }
                                                </TextField>
                                                <FormHelperText>
                                                    {errors.formapgto && <span className="obg">{t('label.required')} </span>}
                                                </FormHelperText>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.parcel2')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {parcelas}</label>x {transformValueFloattoFormated(valorParcelas ? valorParcelas : 0)}
                                            </GridItem>
                                        </GridContainer>
                                        {
                                            item.totalReceberAVista > 0 && !item.pendenciaValorMesAnterior &&
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <h6 className="tRightForm"> {t('label.value_receive_in_cash')}:
                                                        <Tooltip title="Valor a ser recebido a vista: Crédito a vista + valor de 1 parcela" placement="top">
                                                            <Help className="question" />
                                                        </Tooltip> </h6>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <label> {transformValueFloattoFormated(item.totalReceberAVista ? item.totalReceberAVista : 0)} </label>
                                                </GridItem>
                                            </GridContainer>
                                        }
                                        {/* // 05/06/2026 Angelo - Reverter a regra antuga de Antecipação | Commit: c30d8f8
                                        {
                                            (
                                                !item.dataAceite &&
                                                formapgto == "1" &&
                                                (item.valorReceberPagar || 0) > 0 &&
                                                (item.valorRepasseSliptCartaoMatriz || 0) > 0
                                            ) &&
                                            <>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <div style={{ textAlign: 'right', paddingBottom: '10px' }}>
                                                            <label style={{ fontSize: '0.75rem', margin: 0 }}>
                                                                {t('label.calculation_of_the_cash_value')}:
                                                            </label>
                                                        </div>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <label style={{ fontSize: '0.65rem', margin: 0 }}>
                                                            (Split matriz * (Média parcelas * Taxa juros) / 100) = Valor antecipação
                                                        </label>
                                                        <label style={{ fontSize: '0.65rem', margin: 0 }}>
                                                            Total a receber - Valor antecipação = Parcela
                                                        </label>
                                                    </GridItem>
                                                </GridContainer>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <div style={{ textAlign: 'right', paddingBottom: '10px' }}>
                                                            <label style={{ fontSize: '0.75rem', margin: 0 }}>
                                                                Cálculo:
                                                            </label>
                                                        </div>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <label style={{ fontSize: '0.65rem', margin: 0 }}>
                                                            (( {transformValueFloattoFormated(item.valorRepasseSliptCartaoMatriz || 0)} *
                                                            ( {item.mediaParcelas || 0} * {item.valorRepasseSliptCartaoMatriz && item.mediaParcelas ? (item.valorTaxaAntecipacao * 100 / (item.valorRepasseSliptCartaoMatriz * item.mediaParcelas)).toFixed(2).replace('.', ',') :
                                                                "0,00"}) / 100 )) = {transformValueFloattoFormated(item.valorTaxaAntecipacao || 0)}
                                                        </label>
                                                        <label style={{ fontSize: '0.65rem', margin: 0 }}>
                                                            <span>{transformValueFloattoFormated(item.valorReceberPagar || 0)} - </span>
                                                            <span>{transformValueFloattoFormated(item.valorTaxaAntecipacao || 0)} = </span>
                                                            <span>{transformValueFloattoFormated(item.valorReceberComTaxaAntecipacao || 0)} </span>
                                                        </label>
                                                    </GridItem>
                                                </GridContainer>
                                            </>
                                        }
                                        */}
                                    </div>
                                </div>

                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleView()} color="transparent" className={classes.updateProfileButton}>
                                {t('label.return')}
                            </Button>
                            <Button color="rose" onClick={e => { showExtrato() }}>
                                {t('information_message.view_the_extract')}
                            </Button>
                            {!item.dataAceite &&
                                <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                    {t('information_message.confirm_close')}
                                    {loading && <div> ...{t('label.loading')} </div>}
                                </Button>
                            }
                        </div>
                    </GridItem>
                </GridContainer>
            </form>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(false)}
                close
            />

            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description">
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModal(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('register.royalties_extract')} </h4>
                </DialogTitle>
                <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                    style={{ background: '#f0f0f0' }}>
                    <br />
                    {
                        item.franquiaId === 3 ?
                            <ExtratoRoyaltiesDM2 royaltieId={item.royaltieId}></ExtratoRoyaltiesDM2> :
                            <ExtratoRoyalties royaltieId={item.royaltieId}></ExtratoRoyalties>
                    }
                </DialogContent>
            </Dialog>
        </div>
    );
}